import { useAuthStore } from "../../../store/useAuthStore";
import { resetActiveGeniusAuthToken } from "./geniusDeeplinkSession";
import { isGeniusDeeplink } from "./parseGeniusDeeplink";

/**
 * Clear any prior OneApp session before Genius signed-token login.
 * Preserves Genius deeplink session flags — plain logout() would wipe them and
 * disarm Back → about:blank on first-entry deeplink loads.
 */
export function logoutPreviousUserForGeniusDeeplink(
  href: string = typeof window !== "undefined" ? window.location.href : "",
): boolean {
  if (!href || !isGeniusDeeplink(href)) return false;

  const authStore = useAuthStore.getState();
  if (!authStore.token) return false;

  authStore.logout(false, { preserveGeniusDeeplink: true });
  resetActiveGeniusAuthToken();
  return true;
}
